import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import Button from 'components/DesignSystem/Button';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function EmptyState({ onStart }: { onStart: () => void }) {
  return (
    <div className="comparator-empty-state">
      <Icon iconType="stack" color={cssVar('text-accent')} size="large" />
      <h2 className="comparator-empty-state-title">Nenhuma comparação selecionada</h2>
      <p className="comparator-empty-state-text">
        Escolha uma comparação popular, uma preferência salva ou monte uma nova comparação
        entre modelos.
      </p>
      <Button onClick={onStart}>Escolher comparação</Button>
    </div>
  );
}
